<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <div #studentHeader style="padding:10px;" *ngIf=" FeeDialog == false">
        <student-header [pageTitle]="'Fees & Billing'" [showYearSelector]="true" [useYear]="student360Year" (useYearChange)="yearChange($event)" 
            [allowFutureYears]="allowFutureYears">
            <div style="display:flex; justify-content:flex-end;">
                <div>
                    <table class="pull-right" style="white-space:nowrap;">
                        <tr *ngIf="priorBalance != 0">
                            <td style="padding-left:5px; padding-right:30px;" translate>Balance from Prior Year(s)</td>
                            <td style="text-align: right;">&nbsp;${{priorBalance != undefined && priorBalance != null &&
                                priorBalance > 0 ? (priorBalance|number:'1.2-2') : (priorBalance != undefined &&
                                priorBalance != null ? (priorBalance*-1|number:'1.2-2') : '')}}</td>
                            <td style="text-align:left" translate>&nbsp;{{priorBalance > 0 ? 'Credit' : (priorBalance < 0 ? 'Due' :
                                    '' )}}</td>
                        </tr>
                        <tr *ngIf="v10 == true && futureBalance != 0">
                                <td style="padding-left:5px; padding-right:30px;" translate>Balance from Future Year(s)</td>
                                <td style="text-align: right;">&nbsp;${{futureBalance != undefined && futureBalance != null &&
                                        futureBalance > 0 ? (futureBalance|number:'1.2-2') : (futureBalance != undefined &&
                                        futureBalance != null ? (futureBalance*-1|number:'1.2-2') : '')}}</td>
                                    <td style="text-align:left" translate>&nbsp;{{futureBalance > 0 ? 'Credit' : (futureBalance < 0 ? 'Due' :
                                            '' )}}</td>
                            </tr>
                        <tr *ngIf="unappliedPayments != 0 && unappliedPayments != undefined && unappliedPayments != null">
                            <td style="padding-left:5px;padding-right:30px;">{{student360Year.AYIdentifier}} <span translate>Balance</span>
                            </td>
                            <td style="text-align: right;">&nbsp;${{aYBalance != undefined && aYBalance != null &&
                                AYBalance > 0 ? (aYBalance|number:'1.2-2') : (aYBalance != undefined && aYBalance != null ?
                                (aYBalance*-1|number:'1.2-2') : '')}}</td>
                            <td style="text-align:left">&nbsp;{{aYBalance > 0 ? 'Credit' : (aYBalance < 0 ? 'Due' : '' )}}
                            </td>
                        </tr>
                        <tr
                            *ngIf="aYBalance != 0 && aYBalance != undefined && aYBalance != null && (v10 == undefined || v10 == false)">
                            <td style="padding-left:5px;padding-right:30px;">{{student360Year.Description}} <span translate>Balance</span>
                            </td>
                            <td style="text-align: right;">&nbsp;${{aYBalance != undefined && aYBalance != null &&
                                aYBalance > 0 ? (aYBalance|number:'1.2-2') : (aYBalance != undefined && aYBalance != null ?
                                (aYBalance*-1|number:'1.2-2') : '')}}</td>
                            <td style="text-align:left">&nbsp;{{aYBalance > 0 ? 'Credit' : (aYBalance < 0 ? 'Due' : '' )}}
                            </td>
                        </tr>
                        <tr *ngIf="unappliedPayments != 0 && unappliedPayments != undefined && unappliedPayments != null">
                            <td style="padding-left: 5px; padding-right: 30px;" translate>Unapplied Payments</td>
                            <td style="text-align: right;">&nbsp;${{unappliedPayments != undefined && unappliedPayments !=
                                null && unappliedPayments > 0 ? (unappliedPayments|number:'1.2-2') : (unappliedPayments !=
                                undefined && unappliedPayments != null ? (UnappliedPayments*-1|number:'1.2-2') : '')}}</td>
                            <td style="text-align:left">&nbsp;{{unappliedPayments > 0 ? 'Credit' : (unappliedPayments < 0 ?
                                    'Due' : '' )}}</td>
                        </tr>
                        <tr style="height:1px;"
                            *ngIf="(unappliedPayments != 0 && unappliedPayments != undefined && unappliedPayments != null) || (aYBalance != 0 && aYBalance != undefined && aYBalance != null && (v10 == undefined ||v10 == false)) || (priorBalance != 0 && priorBalance != undefined && priorBalance != null)">
                            <td colspan="2">
                                <div style="border-bottom:black solid thin; width:100%;"></div>
                            </td>
                        </tr>
                        <tr *ngIf="v10" style="font-weight:bold;">
                            <td [ngClass]="{'divcellYellowBGColor': (totalBalance * -1) < 0}"
                                style="padding-left: 5px; padding-right:30px;" translate>Total Balance
                            </td>
                            <td style="text-align: right;" [ngClass]="{'divcellYellowBGColor' : (totalBalance * -1) < 0}">&nbsp;${{(totalBalance
                                > 0 ? totalBalance : totalBalance*-1)|number:'1.2-2'}}</td>
                            <td style="text-align:left">&nbsp;{{(totalBalance * -1) > 0 ? 'Credit' : ((totalBalance * -1) <
                                    0 ? 'Due' : '' )}}</td>
                        </tr>
                        <tr *ngIf="!v10" style="font-weight:bold;">
                            <td [ngClass]="{'divcellYellowBGColor': totalBalance < 0}"
                                style="padding-left: 5px; padding-right:30px;" translate>Total Balance
                            </td>
                            <td style="text-align: right;" [ngClass]="{'divcellYellowBGColor' : totalBalance < 0}">&nbsp;${{(totalBalance
                                > 0 ? totalBalance : totalBalance*-1)|number:'1.2-2'}}</td>
                            <td style="text-align:left">&nbsp;{{totalBalance > 0 ? 'Credit' : (totalBalance < 0 ? 'Due' :
                                    '' )}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </student-header>
    </div>
    <div mat-dialog-title="" *ngIf=" FeeDialog == true">Fees & Billing - {{ studentname }} [#{{studentNumber}}]</div>
    <div class="flex-content">
        <div style="height:100%; overflow:auto;flex-grow:1;">

            <div style="text-align:center;" *ngIf="feesAndBilling && feesAndBilling.length == 0" translate>
                No Fees & Billing data exists for this student.
            </div>

            <mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear
                *ngIf="feesAndBilling != undefined && feesAndBilling.length > 0" matSort id="FABdataTable"
                matSortActive="FeeCode" matSortDirection="asc" aria-label="Fees And Billing Table" tabindex="0">
                <!-- Individual column definitions -->
                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;" translate
                        class="print-ignore">More</mat-header-cell>
                    <mat-cell *matCellDef="let FAB" style="min-width:68px;max-width:68px;text-align:center;"
                        class="print-ignore">
                        <span aria-label="Expand row for more details">
                            <i [ngClass]="checkExpanded(FAB) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                                aria-hidden="true"></i>
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="FeeCode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header
                        style="min-width:125px;max-width:300px;margin-right:20px;">
                        <span translate>Fee Code</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="FeeCode" dataType="string"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let FAB" style="min-width:125px;max-width:300px;margin-right:20px;">
                        {{FAB.FeeCode}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Description">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:200px;margin-right:20px;">
                        <span translate>Description</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="Description" dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let FAB" style="min-width:200px;margin-right:20px;">{{FAB.Description}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Balance">
                    <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:150px;">
                        <span translate>Balance</span>
                        <filter class="mat-filter" [data]="angularMatData" columnName="Balance" dataType="string"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let FAB" style="min-width:100px;max-width:150px;">
                        <span [ngStyle]="{'color' : FAB.Balance == 0 ? '#939393' : 'black'}">
                            {{(FAB.Balance != '' && FAB.Balance != null && FAB.Balance > 0 ?
                                                        FAB.Balance : (FAB.Balance != '' && FAB.Balance != null ?
                                                        FAB.Balance*-1 : ''))|number:'1.2-2'}}&nbsp;&nbsp;
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="BalanceType">
                    <mat-header-cell *matHeaderCellDef style="min-width:100px;max-width:100px;"></mat-header-cell>
                    <mat-cell *matCellDef="let FAB" style="min-width:100px;max-width:100px;">
                        <span style="white-space:nowrap;"> {{FAB.Balance > 0 ? 'Credit' : (FAB.Balance < 0 ? 'Due' : '' )}}
                        </span> </mat-cell>
                </ng-container>
                <!-- Expanded Content
                                                            Column - The detail row is made up of this one column that
                                                            spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <!-- Detail row can have standard html or another Angular Material table -->
                    <td mat-cell *matCellDef="let FAB" [attr.colspan]="columnsToDisplay.length" style="width:100%;"
                        class="mat-detail-card">
                        <div style="width:100%;">
                            <fee-payment-details [feePayments]=FAB.FeePayments [v10]=v10></fee-payment-details>
                        </div>
                    </td>
                </ng-container>

                <!-- Row definitions determine what will actually be displayed -->
                <!-- Styles set here will apply to all cells in the row -->
                <!-- Header row -->
                <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="FABdataHeader">
                </mat-header-row>
                <!-- Data rows -->
                <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="FABdataRow{{i}}" tabindex="0"
                    [attr.aria-label]="getAriaRow(row)"
                    [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
                    style="padding:0px;overflow: hidden;" matRipple (click)="toggleExpanded(row)"
                    (keydown)="rowKeyPress($event, row)">
                </mat-row>
                <!-- Detail row -->
                <!-- 'overflow: hidden' is required for animation to render properly -->
                <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                    [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden;"
                    class="mat-detail-row">
                </mat-row>
            </mat-table>
        </div>
    </div>
</tyl-kendo-pdf-export>
<div #footer class="flex-footer">
    <div class="flex-footer-left" *ngIf="!FeeDialog">
        <tyl-button image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)"
            style="padding-left: 10px;"></tyl-button>
        <tyl-button image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)"></tyl-button>
    </div>
    <div class="flex-footer-middle" style="align-items: center">
        <filter-notification [filtered]="angularMatData.isFiltered()"
            (clearFilter)="angularMatData.removeAllFilters(); changeDetector.detectChanges();"></filter-notification>
    </div>
    <div class="flex-footer-right">
        <tyl-button
            *ngIf=" FeeDialog == false && userType==2 && parentPortalShowOnlinePayment==true && onlinePaymentConfiguration.StudentFinesAndFeesOnlinePayment==true && student360Year.EnableOnlinePayment==true"
            image="OnlinePayment.png" label="Online Payment" (clickEvent)="onlinePaymentClick()"
            style="padding-left: 10px;"></tyl-button>
        <tyl-button *ngIf=" FeeDialog == true" style="float:right;" image="cancel.png" label="Close"
            (clickEvent)="closeClick()"></tyl-button>
    </div>
</div>
